import moment from 'moment';
import {WhiteButton} from '@app/Styled/index';
import {get} from 'lodash';
import React, {useEffect} from 'react';
import {Row, Col} from 'react-bootstrap';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {sagaActions} from './redux/saga';

const Activities = ({entityId}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const entityActivities = useSelector(
    (state) => state.entity.entityActivities
  );

  useEffect(() => {
    dispatch({
      type: sagaActions.FETCH_ENTITY_ACTIVITIES,
      payload: {
        entityId,
      },
    });
  }, [entityId]);

  const handleEditActivity = (activityId) => {
    history.push(`/activities/${activityId}`);
  };

  const handleRemoveActivity = () => {};

  const renderActivities = () => {
    return entityActivities.map((activity, index) => {
      const levelFieldsData = JSON.parse(
        get(activity, 'levelFieldsData', '{}')
      );
      const level1Value = get(levelFieldsData, 'Level1.label', '');
      const level2Value = get(levelFieldsData, 'Level2.label', '');
      const modifiedOn = get(activity, 'modifiedOn', '-');
      return (
        <Row
          key={`activity_${activity.id}`}
          className={
            index + 1 < entityActivities.length
              ? 'border-dark border-bottom'
              : ''
          }
        >
          <Col lg={2} className="border-dark border-right">
            {get(activity, 'sourceCategoryName', '-')}
          </Col>
          <Col lg={2} className="border-dark border-right">
            {get(activity, 'emissionSourceName', '-')}
          </Col>
          <Col lg={2} className="border-dark border-right">
            <div>{level1Value}</div>
            {level2Value ? (
              <ul>
                <li>{level2Value}</li>
              </ul>
            ) : null}
          </Col>
          <Col lg={2} className="border-dark border-right">
            {get(activity, 'totalConsumption', '-')}
          </Col>
          <Col lg={2} className="border-dark border-right">
            {get(activity, 'co2Result', '-')}
          </Col>
          <Col lg={1} className="border-dark border-right">
            {modifiedOn !== ''
              ? moment(modifiedOn).format('YYYY-MM-DD')
              : modifiedOn}
          </Col>
          <Col lg={1} className="">
            <WhiteButton
              onClick={() => handleEditActivity(activity.id)}
              size="sm"
              className="m-1"
            >
              Edit
            </WhiteButton>
            <WhiteButton
              onClick={() => handleRemoveActivity(activity.id)}
              size="sm"
              className="m-1"
            >
              Delete
            </WhiteButton>
          </Col>
        </Row>
      );
    });
  };

  return (
    <div className="mt-3">
      <h6>Activities Details</h6>
      <div
        style={{backgroundColor: '#fff', padding: '0px 10px'}}
        className="border border-dark"
      >
        <Row className="border-dark border-bottom">
          <Col lg={2} className="border-dark border-right font-weight-bold">
            Source Category
          </Col>
          <Col lg={2} className="border-dark border-right font-weight-bold">
            Emission Source
          </Col>
          <Col lg={2} className="border-dark border-right font-weight-bold">
            Activity - Fuel
          </Col>
          <Col lg={2} className="border-dark border-right font-weight-bold">
            Quantity (MMBtu)
          </Col>
          <Col lg={2} className="border-dark border-right font-weight-bold">
            Emission&#160;&#160;&#160;&#160; (t CO2)
          </Col>
          <Col lg={1} className="border-dark border-right font-weight-bold">
            Date Modified
          </Col>
          <Col lg={1} className="font-weight-bold">
            Action
          </Col>
        </Row>
        {entityActivities.length ? (
          renderActivities()
        ) : (
          <Row>
            <Col className="text-center">No Activities Found</Col>
          </Row>
        )}
      </div>
    </div>
  );
};

export default Activities;
